<template>
  <v-layout>
    <v-flex xs12>
      <template v-if="loaded">
        <BtReqForm :title="title" :value="request" deletable refreshable :approval="false"
                                    :editable="editable"/>
        <router-view :editable="editable"
          employeeDetailRoute="bt-approval-reqemp-detail"
          employeeNewRoute="bt-approval-reqemp-new"
          employeeDetailBackRoute="business-trip-request-approval"
          expenseListRoute="bt-approval-reqexpense"
          expenseListBackRoute="business-trip-request-approval"
          expenseNewRoute="bt-approval-reqexpense-new"
          expenseDetailRoute="bt-approval-reqexpense-detail"></router-view>
      </template>
      <v-card v-else>
        <v-card-text><h2>Loading...</h2></v-card-text>
      </v-card>
      <ApprovalD v-model="ApprovalDData" @approval="approval" />
    </v-flex>
  </v-layout>
</template>
<script>
import BtReqForm from './BusinessTripRequestForm'
import ApprovalD from '@/components/dialogs/ApprovalConfirmation'
import Vuex from 'vuex'

const btRequestStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Request')
const btRequestEmployeeStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Employees')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

export default {
  components: {
    BtReqForm,
    ApprovalD
  },
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: null
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: 'Approval Business Trip Request',
      request: {},
      loaded: false,
      modified: false
    }
  },
  computed: {
    ...dialogsStore.mapGetters({
      ApprovalDData: 'getApprovalD'
    })
  },
  methods: {
    ...btRequestStore.mapActions({
      getRequest: 'getRequest',
      updateRequest: 'updateRequest',
      deleteRequest: 'deleteRequest'
    }),
    ...btRequestEmployeeStore.mapActions({
      getEmployees: 'getEmployees'
    }),
    loadResources () {
      const self = this
      self.getRequest({vueinstance: self, id: self.id})
        .then(res => {
          this.$showApprovalData({vueinstance: this, data: res.content})
          self.request = res.content
          self.loaded = true
        }).catch(err => self.$error(err))
    },
    approval (data) {
      const self = this

      if (data.action === 'APPROVED') {
        if (self.editable) {
          self.getEmployees({vueinstance: self, id: this.request.id})
            .then(res => {
              if (res.length === 0) {
                self.$error('Must have employee request(s)')
              } else {
                self.updateRequest({vueinstance: self, sppd: this.request, transmode: false})
                  .then(res => {
                    self.$success('Business Trip Request: ' + res.batchNo + ' updated')
                    data.command()
                  }).catch(err => { self.$error(err) })
              }
            })
        } else {
          data.command()
        }
      } else {
        data.command()
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestApproval.vue